// import { useTheme } from 'styled-components/native';
import debounce from 'lodash/debounce';

import { ActivityIndicator, TouchableOpacityProps } from 'react-native';

import { Container, IconFE } from './styles';
import { themes } from '../../design/colors';

interface CommonProps extends TouchableOpacityProps {
  onPress: () => void;
  disabled?: boolean;
  color?: string;
  loading?: boolean;
}

/**
 * Componente do tipo Icon Button para avançar etapas de um fluxo
 *  - 'type': Tipo do botão de acordo com o Design System
 *  - 'onPress': Função realizada ao pressionar o botão
 *  - 'disabled': Desabilita o botão, altera as cores e impede o clique
 *  - 'color': Define a cor do botão, a cor padrão é a primary, caso a cor não seja definida
 */
export default function Circle({ onPress, disabled, color, loading }: CommonProps) {
  return (
    <Container color={color} disabled={disabled} onPress={debounce(onPress, 800, { leading: true, trailing: false })}>
      {loading ? (
        <ActivityIndicator animating color={themes.colors.white} size={'small'} />
      ) : (
        <IconFE name="arrow-right" size={25} color={themes.colors.white} />
      )}
    </Container>
  );
}
